import { InvalidSection, InvalidSections } from '@features/campaigns/shared/types/campaign.ts';
import { CampaignId } from '@shared/types/campaign.ts';

const INVALID_TARGETING_SECTIONS: InvalidSection[] = [
  InvalidSections.TARGETING,
  InvalidSections.INTEREST_SEGMENTS_TARGETING,
  InvalidSections.AGE_GENDER_TARGETING,
  InvalidSections.CONTENT_PACKAGE_TARGETING,
];

function hasInvalidTargetingSections(invalidSectionNames?: InvalidSection[]): boolean {
  return Boolean(invalidSectionNames?.some((section) => INVALID_TARGETING_SECTIONS.includes(section)));
}

export function allowAccessToStep(
  stepIndex: number,
  campaignId?: CampaignId,
  invalidSectionNames?: InvalidSection[],
): boolean {
  switch (stepIndex) {
    case 0:
      return true;
    case 1:
      return Boolean(campaignId);
    case 2:
      return Boolean(campaignId && !hasInvalidTargetingSections(invalidSectionNames));
    case 3:
      return Boolean(
        campaignId &&
          !hasInvalidTargetingSections(invalidSectionNames) &&
          !invalidSectionNames?.includes(InvalidSections.AD_PRODUCTS),
      );
    case 4:
      return Boolean(
        campaignId &&
          !hasInvalidTargetingSections(invalidSectionNames) &&
          !invalidSectionNames?.includes(InvalidSections.AD_PRODUCTS),
      );
    default:
      return true;
  }
}
